'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _id_ID = require('../locale/id_ID');

var _id_ID2 = _interopRequireDefault(_id_ID);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _id_ID2['default'];